export default __webpack_public_path__ + "static/media/portfolio-5.2dcd6723.jpg";